export enum PlannerDateRangeDirection {
  Past = 'past',
  Future = 'future',
}
